enum AuthScopes {
  VIS = 'vis',
  LOGIN_DOT_GOV = 'openid email all_emails',
}

export default AuthScopes;
